import React, { useState, useRef, useEffect } from 'react';
import {
  List,
  ListItem,
  ListItemText,
  TextField,
  Paper
} from '@material-ui/core';
import styled from 'styled-components';

const ChoiceItem = styled(ListItem)`
  &:hover {
    background-color: #bff9ff;
  }
  cursor: default;
`;

const ChoiceMenu = styled(Paper)`
  max-height: 250px;
  overflow-y: auto;
  z-index: 2;
  position: absolute;
`;

const filterChoices = (choices, value) => {
  let newChoices = [];
  if (choices) {
    choices.forEach(choice => {
      if (choice.toLowerCase().startsWith(value.toLowerCase())) {
        newChoices.push(choice);
      }
    });
    newChoices.sort();
  }
  return newChoices;
};

function DropdownCombobox({
  initialValue,
  choices,
  onValueChange,
  inputProps
}) {
  const [value, setValue] = useState(initialValue);
  const [items, setItems] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [width, setWidth] = useState(0);

  const ref = useRef(null);

  const setNewValue = value => {
    setValue(value);
    onValueChange(value);
  };

  const onBlur = e => {
    setIsOpen(false);
    if (!clicked) {
      setNewValue(e.target.value);
    } else {
      setClicked(false);
    }
  };

  const onChange = e => {
    const val = e.target.value;
    const newItems = filterChoices(choices, val);
    setValue(val);
    setItems(newItems);
    setIsOpen(newItems.length > 0);
  };

  const onMouseDown = e => {
    setNewValue(e.currentTarget.getAttribute('value'));
    setIsOpen(false);
    setClicked(true);
  };

  useEffect(() => {
    setWidth(ref.current.clientWidth);
  }, []);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <>
      <div ref={ref}>
        <TextField
          onChange={onChange}
          value={value}
          onBlur={onBlur}
          {...inputProps}
        />
      </div>
      <ChoiceMenu style={{ width: width }}>
        <List hidden={!isOpen} dense={true}>
          {items.map((item, idx) => {
            return (
              <ChoiceItem
                onMouseDown={onMouseDown}
                key={`${item}-${idx}`}
                value={item}
              >
                <ListItemText primary={item} />
              </ChoiceItem>
            );
          })}
        </List>
      </ChoiceMenu>
    </>
  );
}

export default DropdownCombobox;
